import axios from "axios";

if (document.querySelector('.cost__box')) {
    getSubscribes();

    async function getSubscribes() {
        try {
            let response = await axios.get('/subscribe');

            document.querySelectorAll('.cost__connect-price-big').forEach(($item, index) => {
                const currentSubId = parseInt($item.dataset.subscribe);

                $item.innerHTML = response.data.find(sub => sub.id === currentSubId).price + '€';
            })
        } catch (event) {
            console.dir(event);
        }
    }
}
